import { addSheetBackLink, PARENT_SHEETS } from "../sheetNavigation";
import { getFinancialYearLabels } from "../../brsrFinancialYearLabels";
import {
  COL_D,
  COL_E,
  COL_F,
  COL_G,
  COL_H,
  COL_I,
  COL_J,
  COL_K,
  HEADER_FILL,
  TABLE_HEADER_FILL,
  formatPercent,
  mergeRow,
  safeText,
  setCell,
} from "./principle3SheetHelpers";

const TITLE_ROW = 3;
const HEADER_ROW = 4;

export const SHEET_NAME = "Other retirement benefits";

export function buildOtherRetirementBenefitsSheet(workbook, sectionC, reportingYear = "") {
  const ws = workbook.addWorksheet(SHEET_NAME, { views: [{ showGridLines: true }] });
  const fy = getFinancialYearLabels(reportingYear);
  const fyCurrent = fy.currentYear ? `FY (${fy.currentYear})` : "FY (Current Financial Year)";
  const fyPrevious = fy.previousYear ? `PY (${fy.previousYear})` : "PY (Previous Financial Year)";

  ws.getColumn("A").width = 2;
  ws.getColumn("B").width = 2;
  ws.getColumn("C").width = 2;
  ws.getColumn("D").width = 8;
  ws.getColumn("E").width = 22;
  ws.getColumn("F").width = 16;
  ws.getColumn("G").width = 16;
  ws.getColumn("H").width = 14;
  ws.getColumn("I").width = 16;
  ws.getColumn("J").width = 16;
  ws.getColumn("K").width = 14;

  addSheetBackLink(ws, PARENT_SHEETS.PRINCIPLE_3, { mergeEnd: COL_K });

  const retirement = sectionC?.principle3?.essentialIndicators?.retirementBenefits || {};
  const current = retirement?.currentFinancialYear?.others || {};
  const previous = retirement?.previousFinancialYear?.others || {};
  const benefitName = safeText(current?.headerOthers || previous?.headerOthers, "Others - please specify");

  mergeRow(ws, TITLE_ROW, COL_D, COL_K, "Other retirement benefits", {
    bold: true,
    fill: HEADER_FILL,
    align: "center",
  });

  setCell(ws, HEADER_ROW, COL_D, "Sr. No.", { bold: true, fill: TABLE_HEADER_FILL, align: "center" });
  setCell(ws, HEADER_ROW, COL_E, "Benefits", { bold: true, fill: TABLE_HEADER_FILL, align: "center" });
  mergeRow(ws, HEADER_ROW, COL_F, COL_H, fyCurrent, { bold: true, fill: TABLE_HEADER_FILL, align: "center" });
  mergeRow(ws, HEADER_ROW, COL_I, COL_K, fyPrevious, { bold: true, fill: TABLE_HEADER_FILL, align: "center" });

  const subHeaderRow = HEADER_ROW + 1;
  setCell(ws, subHeaderRow, COL_D, "", { fill: TABLE_HEADER_FILL });
  setCell(ws, subHeaderRow, COL_E, "", { fill: TABLE_HEADER_FILL });
  setCell(ws, subHeaderRow, COL_F, "Employees covered (%)", { bold: true, fill: TABLE_HEADER_FILL, align: "center" });
  setCell(ws, subHeaderRow, COL_G, "Workers covered (%)", { bold: true, fill: TABLE_HEADER_FILL, align: "center" });
  setCell(ws, subHeaderRow, COL_H, "Deducted (Y/N/NA)", { bold: true, fill: TABLE_HEADER_FILL, align: "center" });
  setCell(ws, subHeaderRow, COL_I, "Employees covered (%)", { bold: true, fill: TABLE_HEADER_FILL, align: "center" });
  setCell(ws, subHeaderRow, COL_J, "Workers covered (%)", { bold: true, fill: TABLE_HEADER_FILL, align: "center" });
  setCell(ws, subHeaderRow, COL_K, "Deducted (Y/N/NA)", { bold: true, fill: TABLE_HEADER_FILL, align: "center" });

  const row = subHeaderRow + 1;
  setCell(ws, row, COL_D, "1", { align: "center" });
  setCell(ws, row, COL_E, benefitName, { align: "left" });
  setCell(ws, row, COL_F, formatPercent(current?.employeesCovered), { align: "center" });
  setCell(ws, row, COL_G, formatPercent(current?.workersCovered), { align: "center" });
  setCell(ws, row, COL_H, safeText(current?.deductedDeposited), { align: "center" });
  setCell(ws, row, COL_I, formatPercent(previous?.employeesCovered), { align: "center" });
  setCell(ws, row, COL_J, formatPercent(previous?.workersCovered), { align: "center" });
  setCell(ws, row, COL_K, safeText(previous?.deductedDeposited), { align: "center" });

  return ws;
}
